
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { CampusService } from '@services/campus.service';
import { CampusTypeService } from '@services/campusType.service';

@Component({
  selector: 'app-user-campus',
  templateUrl: './campus.component.html',
  styleUrls: ["./campus.component.css"],
  imports: [PanelComponent, FormsModule, ReactiveFormsModule, NgSelectModule],
  providers: [CampusService, CampusTypeService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampusComponent implements OnInit {

  private _campusService = inject(CampusService)
  private _campusTypeService = inject(CampusTypeService)
  private _fb = inject(FormBuilder)
  private _modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected campus: any
  protected search = ""
  protected listTypesCampus: any[] = []

  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public closeResult = ""
  protected newCampusForm = this._fb.group({
    _id: [null],
    name: ["", Validators.required],
    acronym: ["", Validators.required],
    typeId: [null],
    priority: [0, Validators.required],
    enabled: [true],
  })

  ngOnInit(): void {
    this.getCampus();
    this.loadTypes();
  }

  open(modal: any, role?: any) {
    this.newCampusForm.reset();
    this.newCampusForm.patchValue({ enabled: true, typeId: null })
    if (role) {
      this.newCampusForm.patchValue({
        _id: role._id,
        name: role.name,
        acronym: role.acronym,
        typeId: role.typeId,
        priority: role.priority,
        enabled: role.enabled
      })
    }
    this._modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  loadTypes() {
    this._campusTypeService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.listTypesCampus = res
      this.cdr.markForCheck()
    })
  }

  getCampus() {
    this._campusService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((roles) => {
      this.campus = roles.map((c: any, i: any) => ({ ...c, priority: i }));
      this.cdr.markForCheck()
    });
  }

  saveCampus() {
    if (this.newCampusForm.value._id) {
      this._campusService.update(this.newCampusForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    } else {
      const priority = this.campus?.length ?? 0
      this.newCampusForm.patchValue({ priority })
      this._campusService.create(this.newCampusForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => this.getCampus())
      return
    }
    this.getCampus()
  }

  enabledCampus(role: any) {
    role.enabled = !role.enabled
    this._campusService.update(role).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  moveUp(index: number) {
    if (index <= 0) return
    this.swapPriority(index, index - 1)
  }

  moveDown(index: number) {
    if (index >= this.campus.length - 1) return
    this.swapPriority(index, index + 1)
  }

  private swapPriority(from: number, to: number) {
    const idFrom = this.campus[from]._id
    const idTo = this.campus[to]._id

    const temp = this.campus[from].priority
    this.campus[from].priority = this.campus[to].priority
    this.campus[to].priority = temp

    this.campus = [...this.campus].sort((a, b) => a.priority - b.priority)

    const itemFrom = this.campus.find((c: any) => c._id === idFrom)!
    const itemTo = this.campus.find((c: any) => c._id === idTo)!
    this._campusService.update(itemFrom).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    this._campusService.update(itemTo).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
  }

} 
